import * as Yup from 'yup';
import { PaymentFrequency } from './enums';

export const baseAmountSchema = Yup.object({
  amount: Yup.number().optional(),
  grossAmount: Yup.number().optional(),
  netAmount: Yup.number().optional(),
  currency: Yup.string().optional(),
});

export const responseAmountSchema = baseAmountSchema.shape({
  paymentFrequency: Yup.mixed<PaymentFrequency>().oneOf(Object.values(PaymentFrequency)).optional(),
});
